import { withLoyaltyPromoProps } from 'viewModel/reward/loyaltyPromo/withLoyaltyPromoProps';
import LoyaltyPromo from 'components/Reward/LoyaltyPromo/LoyaltyPromo';

export default withLoyaltyPromoProps(LoyaltyPromo);
